// @flow
import React from 'react';
import styles from './PlansOverviewSummary.css';
import { FormattedMessage } from 'react-intl';

type OwnProps = {
  isTrialAvailable: boolean,
  trialDurationDays: number,
  isValentine26Campaign: boolean,
};

type Props = OwnProps;

const PlansOverviewSummary = ({
  isTrialAvailable,
  trialDurationDays,
  isValentine26Campaign,
}: Props) => {
  const Description = () => {
    if (isValentine26Campaign) {
      return (
        <div className={styles.description}>
          <FormattedMessage
            id="premium.plan-summary.trial.description.valentine26"
            defaultMessage="Cupid is gifting you {trialDurationMonths} months to test us for free. No commitments, no hidden thorns – cancel anytime."
            values={{ trialDurationMonths: Math.ceil(trialDurationDays / 30) }}
          />
        </div>
      );
    }

    if (isTrialAvailable) {
      return (
        <div className={styles.description}>
          <FormattedMessage
            id="premium.plan-summary.trial.description"
            defaultMessage="All plans come with a {trialDurationDays}-day free trial period! No commitment. Cancel anytime."
            values={{ trialDurationDays }}
          />
        </div>
      );
    }
    return null;
  };

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>
        <FormattedMessage id="premium.plan-summary.title-2" defaultMessage="Choose Your Plan" />
      </h1>
      <Description />
    </div>
  );
};

export default PlansOverviewSummary;
